import {Component, OnDestroy, OnInit} from '@angular/core';
import {RouterModule, RouterOutlet} from '@angular/router';
import {ButtonModule} from 'primeng/button';
import {TranslationPipe} from '../../pipes/translation.pipe';
import {DashboardTitleService} from '../../services/dashboard-title.service';

import {BreadcrumbModule} from 'primeng/breadcrumb';
import {MenuItem} from 'primeng/api';
import {DateTime} from 'luxon';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {FeedbackWidgetComponent} from '../widgets/feedback-widget/feedback-widget.component';
import {BreadcrumbsComponent} from './breadcrumbs/breadcrumbs.component';
import {Location} from '@angular/common';
import {SubscriptionManager} from '../../services/subscription-manager.service';

@Component({
  selector: 'app-loggedin',
  imports: [RouterOutlet, BreadcrumbModule, ButtonModule, TranslationPipe, RouterModule, TranslationPipe, BreadcrumbsComponent],
  providers: [TranslationPipe,SubscriptionManager],
  templateUrl: './loggedin.component.html',
  styleUrl: './loggedin.component.scss'
})
export class LoggedinComponent implements OnInit {
  titleMap!: Map<string, string>;
  breadcrumbItems!: MenuItem[];
  ref!: DynamicDialogRef<FeedbackWidgetComponent> | null;

  constructor(
    private readonly subscriptionManager: SubscriptionManager,
    private readonly translationPipe: TranslationPipe,
    public dashboardService: DashboardTitleService,
    private readonly dialogService: DialogService,
    private readonly location: Location) {}

  ngOnInit(): void {
    this.titleMap = new Map<string, string>();
    this.titleMap.set("/loggedin/customers", this.translationPipe.transform("Title.Customers"));
    this.titleMap.set("/loggedin/settings", this.translationPipe.transform("Title.Settings"));
    this.titleMap.set("/loggedin/customers/create", this.translationPipe.transform("Title.CreateCustomers"));
    this.titleMap.set("/loggedin/customers/edit/.*", this.translationPipe.transform("Title.EditCustomers"));
    this.titleMap.set("/loggedin/pets/create", this.translationPipe.transform("Title.CreatePets"));
    this.titleMap.set("/loggedin/pets/edit/.*", this.translationPipe.transform("Title.EditPets"));
    this.titleMap.set("/loggedin/treatments/create", this.translationPipe.transform("Title.CreateTreatments"));
    this.titleMap.set("/loggedin/treatments/edit/.*", this.translationPipe.transform("Title.EditTreatments"));
    this.titleMap.set("/loggedin/dashboard", this.translationPipe.transform("Title.Dashboard"));
    this.titleMap.set("/loggedin/images/annotate", this.translationPipe.transform("Title.AnnotateImages"));

    this.subscriptionManager.call(
      this.dashboardService.breadCrumbData,
      (x => {
        if (
          x.customerFirstname &&
          x.customerLastname &&
          x.petName &&
          x.customerId &&
          x.petId &&
          x.treatmentDate) {
          this.breadcrumbItems = [
            {
              label: (x.customerFirstname + " " + x.customerLastname).toLocaleUpperCase(),
              routerLink: ["/loggedin/customer-detail/" + x.customerId]
            },
            {label: x.petName.toLocaleUpperCase(), routerLink: ["/loggedin/pet-detail/" + x.petId]},
          ]
          if (globalThis.location.pathname.includes("/loggedin/treatment-detail/")) {
            this.breadcrumbItems.push({
              label: `${x.treatmentTitle} (${this.getDateAndTime(x.treatmentDate)})`,
              routerLink: ["/loggedin/treatment-detail/" + x.treatmentId]
            })
          }
        }
      })
    );
  }

  getDateAndTime(date: DateTime) {
    return date.toLocaleString({day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'});
  }

  setButtonState(buttonlink: string): "success" | "info" | "warn" | "danger" | "help" | "primary" | "secondary" | "contrast" | null | undefined {
    if (globalThis.location.href.includes(buttonlink)) {
      return 'primary'
    } else {
      return 'secondary'
    }
  }

  getTitle() {
    for (let [key, value] of this.titleMap) {
      let regex = new RegExp(`^${key}$`, "i");
      if (new RegExp(regex).exec(globalThis.location.pathname)) {
        return value.toLocaleUpperCase();
      }
    }
    return (this.dashboardService.customerFirstname + " " + this.dashboardService.customerLastname).toLocaleUpperCase();
  }

  shouldShowBreadcrumbs(): boolean {
    return globalThis.location.pathname.includes("/loggedin/pet-detail/") || globalThis.location.pathname.includes("/loggedin/treatment-detail/");
  }


  protected openFeedbackWidget() {
    this.ref = this.dialogService.open(FeedbackWidgetComponent, {
      modal: true,
      closeOnEscape: true,
      closable: true,
      data: {
        concerningPage: this.getCleanedPath(this.location.path())
      }
    });
    if (this.ref)
      this.subscriptionManager.call(
        this.ref.onClose,
        (x => {
          this.ngOnInit();
        })
      );
  }

  private getCleanedPath(path: string): string {
    path = path.split('?')[0];
    const segments = path.split("/");
    // Entfernt das letzte Segment, falls es eine ID (UUID) ist
    const lastSegment = segments.at(-1);
    const idPattern = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-.*$/; // Erkennt UUIDs

    if (idPattern.test(lastSegment ?? "")) {
      segments.pop();
    }

    return segments.join('/').replace(/^\//, '');
  }
}
